export default __webpack_public_path__ + "static/preview-7558855d01cf59c0284185b939aeab64.png";